module.exports = __webpack_public_path__ + "static/media/shipSVG.dee33063.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/shipSVG.svg
// module id = 214
// module chunks = 0